// import { flare } from "@flareapp/flare-client";

// only launch in production, we don't want to waste your quota while you're developing.
// if (process.env.NODE_ENV === 'production') {
//   flare.light('mdLjScU9JydvjUwmCTTfb8edKa3mslPx');
// }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios"
window.axios = axios

window.axios.defaults.headers.common = {
  "X-CSRF-TOKEN": window.FinancialCents.csrfToken,
  "X-Requested-With": "XMLHttpRequest",
  Accept: "application/json",
  Authorization: window.FinancialCents.auth,
}

/**
 * Make sure the user is notified when they are logged out.
 *
 * @type {boolean}
 */
window.loggedOut = false
window.axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error(error.response ? error.response.status : error)
    if (!window.loggedOut && error.response && error.response.status === 401) {
      window.loggedOut = true
      // alert('For your security, we have paused your session. Please refresh the page to sign in.')
      // window.location.reload()
    }
    return Promise.reject(error)
  },
)

// Set CSRF Tokens every 1 hour
setInterval(
  () => {
    axios
      .get("/api/contract/renew")
      .then((response) => {
        const _token = response.data.data._token

        window.FinancialCents.csrfToken = _token

        window.axios.defaults.headers.common = {
          "X-CSRF-TOKEN": _token,
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          Authorization: window.FinancialCents.auth,
        }
      })
      .catch((error) => {
        // ignore errors
        console.error(error)
      })
  },
  1000 * 60 * 60,
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"
import Pusher from "pusher-js"

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: "pusher",
  key: window.keys.pusher,
  cluster: "us2",
  forceTLS: window.FinancialCents.env === "production",
  auth: {
    headers: {
      Authorization: window.FinancialCents.auth,
    },
  },
})
